module.exports = __webpack_public_path__ + "static/media/seite.5416c474.svg";